import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import withLoading from 'Layout/withLoading';
import UserEmailFormPlaceholder from './UserEmailFormPlaceholder';
import { withLocale } from '../../../TranslatorContext';

class UserEmailForm extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        email: PropTypes.string.isRequired,
    };

    render() {
        return (
            <Container>
                <Row>
                    <Col xs="12" md={{ size: 8, offset: 2 }}>
                        <h2 className="heading-3">
                            {this.props.t('settings/profile')}
                        </h2>
                        <p>{this.props.email}</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withLoading(withLocale(UserEmailForm), UserEmailFormPlaceholder);
